$(".variant-picker__wrapper input[type=radio]").change((function() {
  var variantVal = $(this).val();
  var variantPolicy = $(this).attr('data-vpolicy');
  var variantQty = $(this).attr('data-vqty');
  
  
  // klavio form display on soldout variant and policy deny
  if($(this).hasClass("sold-out") && variantPolicy == 'deny'){
      $('.app_inner_wrp.klavio_waitlist_form').addClass('soldout__variant');
  }else {
    $('.app_inner_wrp.klavio_waitlist_form').removeClass('soldout__variant');
  }

  // show preorder button and custom info message pass variant nameon change
  if(variantPolicy == 'continue' && variantQty <= 0){
    $('.custom_ava_info_text_wrp').removeClass('show_avaiable_info');
    $('.custom_info_text_wrp').addClass('show_message');
    if(variantVal != 'Default Title'){
      var customInfo = $(this).closest(".product__form__wrapper").find('.custom_info_text_wrp p span.vartxt');
      if(customInfo && variantVal){
        customInfo.text(variantVal);
      }
    }
    setTimeout(function () {
    if($('.custom_info_text_wrp').hasClass('show_message')){
        $('span.atc_txxt').text(theme.strings.preorder);
      }
    },1000);
  }else{
    
    if($(this).hasClass("sold-out")){
      $('.custom_ava_info_text_wrp').removeClass('show_avaiable_info');
    }else{
       $('.custom_info_text_wrp').removeClass('show_message');
       $('.custom_ava_info_text_wrp').addClass('show_avaiable_info');
       if(variantVal != 'Default Title'){
          var customInfo = $(this).closest(".product__form__wrapper").find('.custom_ava_info_text_wrp p span.vartxt');
          if(customInfo && variantVal){
            customInfo.text(variantVal);
          }
       }
    }
  }

  // color swatch selected value assign to addon checkbox addon products
   var variantObj = $(this);
  //  console.log(variantObj);
   var addonSelectedVal = $(this).next().attr('data-myvariant');
   var addonSelectedImgVal = $(this).next().attr('data-myvariantimg');
   $(this).closest('.main_addon_wrp').find('input[type=checkbox]').val(addonSelectedVal);
   $(this).closest('.main_addon_wrp').find('.product-addon_product__image__thumb').css('background-image', 'url(' + addonSelectedImgVal + ')');



  // product upsell id change on change
        var mySelectedVal = $(this).next().attr('data-myvariant');
        var mySelectedImgVal = $(this).next().attr('data-myvariantimg');
        var myvariantavailable = this.nextElementSibling.getAttribute('data-myvariantavailable');
        var btn = this.closest('form.product-upsell__form').querySelector('.product-upsell__btn');

        if (myvariantavailable === "false") {
          btn.classList.add("disabled");
        } else {
          btn.classList.remove("disabled");
        }
        $(this).closest('form.product-upsell__form').find('input[name=id]').val(mySelectedVal);
        $(this).closest('.product-upsell__holder').find('.product-upsell__image__thumb').css('background-image', 'url(' + mySelectedImgVal + ')');

}));
// product upsell
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".swatch__label").forEach(function (label) {
    if (label.dataset.myvariantavailable === "false") {
      const swatchButton = label.closest(".swatch__button");
      if (swatchButton) {
        const input = swatchButton.querySelector("input[type='radio']");
        if (input) {
          input.classList.add("sold-out");
        }
      }
    }
  });
});


$(document).ready(function(){
  setTimeout(function () {
    if($('.custom_info_text_wrp').hasClass('show_message')){
      $('span.atc_txxt').text(theme.strings.preorder);
    }
  },1000);
});


// bundle page swatch hide show message
$(document).ready(function () {
  $('.bundle-color-swatch .radio__fieldset .swatch__button').on('click', function() {
    var dataInfo = $(this).find('.swatch__label');
    var messageinfoAvailableSelector = $(this).closest('.bundle-builder').find('.custom_ava_info_text_wrp');
    var messageinfoSoldoutSelector = $(this).closest('.bundle-builder').find('.custom_info_text_wrp');
    var variantVal = dataInfo.attr('data-variant-title');
    var variantPolicy = dataInfo.attr('data-vpolicy');
    var variantQty = dataInfo.attr('data-vqty');

    

    // custom info message pass variant nameon change
    if(variantPolicy == 'continue' && variantQty <= 0){
      console.log(messageinfoAvailableSelector);
      console.log(messageinfoSoldoutSelector);
       messageinfoAvailableSelector.removeClass('show_avaiable_info');
       messageinfoSoldoutSelector.addClass('show_message');
      if(variantVal != 'Default Title'){
        var customInfo = messageinfoSoldoutSelector.find('p span.vartxt');
        if(customInfo && variantVal){
          customInfo.text(variantVal);
        }
      }
      
    }else{
        messageinfoSoldoutSelector.removeClass('show_message');
        messageinfoAvailableSelector.addClass('show_avaiable_info');
       if(variantVal != 'Default Title'){
          var customInfo = messageinfoAvailableSelector.find('p span.vartxt');
          if(customInfo && variantVal){
            customInfo.text(variantVal);
          }
       }
    }
    
  });
});

// landing page Auto atc product
var autopid = 56113759846782; // extra product variant ID
let autoAdded = false;
console.log("loaded");

document.addEventListener('click', async (e) => {

  const btn = e.target.closest('#ctm_btn_ecomp_set .ecom-product-single__add-to-cart--submit');
  if (!btn || autoAdded) return;

  autoAdded = true;
  e.preventDefault();

  try {
    // Get main product quantity
    const qtyInput = document.querySelector('.ecom-product-single__quantity-input');
    const mainQty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

    // Prepare data for CO2 cylinder (extra product)
    const data = {
      items: [{ id: autopid, quantity: mainQty }]
    };

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'xmlhttprequest'
      },
      body: JSON.stringify(data),
      credentials: 'same-origin'
    });

    if (!response.ok) throw new Error('Extra product add failed');
    console.log(`✅ Extra product added (${mainQty}x)`);

    // Proceed with main product add
    btn.click();
  } catch (err) {
    console.error('❌ Auto ATC failed:', err);
    btn.click();
  } finally {
    autoAdded = false; // reset flag for next click
  }
});




document.addEventListener("DOMContentLoaded", function () {

  // Listen for subscription plan changes
  document.querySelectorAll('[name="selling-plan-group"], [name="selling_plan"]').forEach(input => {
    input.addEventListener("change", function (event) {

      // Find correct bundle block
      const bundleWrapper = event.target.closest('.bundle-wrapper, .bundle-picker__wrapper');

      if (!bundleWrapper) return;

      // Read selected plan
      const selected = bundleWrapper.querySelector('input[name="selling_plan"]:checked');
      const planValue = selected ? selected.value : "";

      // Update hidden selling plan input inside this bundle
      const hiddenField = bundleWrapper.querySelector('.bundle-selling-plan');
      if (hiddenField) {
        hiddenField.value = planValue;
        console.log("Updated selling plan:", planValue);
      }
    });
  });

});



document.addEventListener("DOMContentLoaded", function () {

  // function to update the save text
  function updateSaveBox(planInput) {
    const save = planInput.dataset.save || '';
    const saveBox = document.querySelector('.saved_txt_plan');

    if (saveBox) {
      if (save) {
        saveBox.textContent = `save: ${save}`;
        saveBox.classList.remove('hidden');
      } else {
        saveBox.textContent = '';
        saveBox.classList.add('hidden');
      }
    }
  }

  // 1. RUN ON LOAD → find the default selected plan
  const defaultPlan = document.querySelector('input[name="selling_plan"]');
  if (defaultPlan) {
    updateSaveBox(defaultPlan);
  }

  // 2. RUN ON CHANGE
  document.querySelectorAll('input[name="selling_plan"]').forEach(radio => {
    radio.addEventListener('change', function () {
      updateSaveBox(this);
    });
  });
});

